"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
function removeCourseEnrollments(courseId, courseEnrollmentQueries) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const courseEnrollmentRef = app_1.app.firestore.collection('courseEnrollments');
            const courseEnrollmentSnapshots = yield courseEnrollmentRef
                .where('courseId', '==', courseId)
                .get();
            if (courseEnrollmentSnapshots.empty) {
                return { message: 'Cannot find doc with provided parameter values' };
            }
            else {
                const batch = app_1.app.firestore.batch();
                // batch delete operations for matching userIds
                courseEnrollmentSnapshots.forEach((courseEnrollmentSnapshot) => {
                    const { userId } = courseEnrollmentSnapshot.data();
                    const indexOfUserId = courseEnrollmentQueries.findIndex((courseEnrollmentQuery) => courseEnrollmentQuery.userId === userId);
                    if (indexOfUserId !== -1) {
                        batch.delete(courseEnrollmentSnapshot.ref);
                    }
                });
                yield batch.commit();
                // decrement noOfStudents counter for that course
                const courseRef = app_1.app.firestore.collection('courses').doc(courseId);
                const courseDoc = yield courseRef.get();
                const noOfStudents = courseDoc.data().noOfStudents;
                yield courseRef.update({ noOfStudents: noOfStudents - courseEnrollmentQueries.length });
                return { message: 'Docs deleted successfully.' };
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = removeCourseEnrollments;
//# sourceMappingURL=removeCourseEnrollments.js.map